



// =============== audio ============

export const ass_audio_firstLoad            = require("../audio/firstLoad.mp3")

export const ass_audio_pageFlipping         = require("../audio/page_flipping.wav")
export const ass_audio_pageTurn             = require("../audio/page_turn.wav")
export const ass_audio_error                = require("../audio/error.wav")

export const ass_audio_notifyChat           = require("../audio/notify.wav")
export const ass_audio_notifyMissions       = require("../audio/notifiy_mission_changeStatus.mp3")

export const ass_audio_finishRiddle         = require("../audio/finishRiddle.mp3")
export const ass_audio_finishLastRiddle     = require("../audio/finishLastRiddle.mp3")
export const ass_audio_finishMissionRiddle  = require("../audio/jingle_achievement.wav")

// =============== gif ============

export const ass_gif_goToQuests  = require("../gifs/goToQuests.gif")
export const ass_gif_enterQuest  = require("../gifs/enterQuest.gif")
export const ass_gif_useTicket  = require("../gifs/useTicket.gif")
export const ass_gif_videoPlayer_poster  = require("../gifs/videoPlayer_poster.gif")
export const ass_gif_trophy  = require("../gifs/trophy.gif")
export const ass_gif_gpsSearchingLocation  = require("../gifs/gpsSearchingLocation.gif")
export const ass_gif_gpsCalibrate  = require("../gifs/gpsCalibrate.gif")


// =============== video ============

export const ass_video_gameChart  = require("../videos/gameChart.mp4")
export const ass_video_enterShortCode  = require("../videos/enterShortCode.mp4")



// =============== images ============

export const ass_image_coming_soon  = require("../images/coming_soon.jpg")

export const ass_image_store_outside  = require("../images/store_outside.jpg")
export const ass_image_store_fromHome  = require("../images/store_fromHome.jpg")



// =============== explore ============


export const ass_svg_computer_c  = require("../svg/computer_c.svg")
export const ass_svg_map_c  = require("../svg/map_c.svg")
export const ass_svg_guide_c  = require("../svg/guide_c.svg")
export const ass_svg_guide_b  = require("../svg/guide_b.svg")
export const ass_svg_noGuide_c  = require("../svg/noGuide_c.svg")
export const ass_svg_noGuide_b  = require("../svg/noGuide_b.svg")



export const ass_svg_map_w  = require("../svg/map_w.svg")


// =============== svg ============

export const ass_svg_muteSpeakers_b  = require("../svg/mute_speaker_b.svg")

export const ass_img_svg_key_w = require("../svg/key_w.svg")
export const ass_img_svg_key_p = require("../svg/key_p.svg")
export const ass_img_svg_key_b = require("../svg/key_b.svg")

export const ass_img_pointStart_p = require("../svg/point_starting_p.svg")
export const ass_img_pointStart_w = require("../svg/point_starting_w.svg")
export const ass_img_pointBody_p = require("../svg/point_body_p.svg")
export const ass_img_pointBody_w = require("../svg/point_body_w.svg")
export const ass_img_pointEnd_p = require("../svg/point_ending_p.svg")
export const ass_img_pointEnd_w = require("../svg/point_ending_w.svg")


export const ass_img_skip_w = require('../svg/skip4_w.svg')
export const ass_img_skip_p = require('../svg/skip4_p.svg')
export const ass_img_skip_g = require('../svg/skip4_g.svg')
export const ass_img_unlock = require("../svg/unlock.svg")
export const ass_img_unlock_bgGreen_w = require("../svg/unLock_BgWhite_w.svg")
export const ass_img_unlock_yellow = require("../svg/unLock_yellow.svg")
export const ass_img_unlock2_w = require("../svg/unlock2_w.svg")
export const ass_img_unlock_r = require("../svg/unlock_r.svg")

export const ass_img_checked = require("../svg/checked_bgGreen.svg")
export const ass_img_checked_w = require("../svg/checked_w.svg")
export const ass_img_checked_b = require("../svg/checked_b.svg")
export const ass_img_checked_bgWhite = require("../svg/checked_bgWhite.svg")
export const ass_img_checked_gray = require("../svg/checked_gray.svg")
export const ass_img_checked_green = require("../svg/checked_green.svg")

export const ass_img_chart_w = require('../svg/chart_w.svg')
export const ass_img_gps_w = require('../svg/gps_w.svg')
export const ass_img_dice_w = require('../svg/dice_w.svg')


export const ass_img_diffLevel0_gray = require('../svg/difficultyLevel_0.svg')
export const ass_img_diffLevel1_c = require('../svg/difficultyLevel_1.svg')
export const ass_img_diffLevel1_gray = require('../svg/difficultyLevel_1_gray.svg')
export const ass_img_diffLevel2_c = require('../svg/difficultyLevel_2.svg')
export const ass_img_diffLevel2_gray = require('../svg/difficultyLevel_2_gray.svg')
export const ass_img_diffLevel3_c = require('../svg/difficultyLevel_3.svg')
export const ass_img_diffLevel3_gray = require('../svg/difficultyLevel_3_gray.svg')
export const ass_img_diffLevel4_c = require('../svg/difficultyLevel_4.svg')
export const ass_img_diffLevel4_gray = require('../svg/difficultyLevel_4_gray.svg')
export const ass_img_diffLevel5_c = require('../svg/difficultyLevel_5.svg')
export const ass_img_diffLevel5_gray = require('../svg/difficultyLevel_5_gray.svg')

export const ass_img_ticket2_g = require('../svg/ticket_g.svg')
export const ass_img_ticket2_o = require('../svg/ticket_o.svg')
export const ass_img_ticket2_blue = require('../svg/ticket_blue.svg')
export const ass_img_ticket2_p = require('../svg/ticket_p.svg')
export const ass_img_ticket2_black = require('../svg/ticket_black.svg')

export const ass_img_ticket_w = require('../svg/ticket_w.svg')
export const ass_img_pay_w = require('../svg/pay_w.svg')
export const ass_img_order_w = require('../svg/order.svg')
export const ass_img_hand_shake_w = require('../svg/hand_shake_w.svg')
export const ass_img_add_b = require('../svg/add_b.svg')
export const ass_img_add_w = require('../svg/add_w.svg')
export const ass_img_minus_w = require('../svg/minus_w.svg')
export const ass_img_garbage_w = require('../svg/garbage_w.svg')
export const ass_img_garbage = require('../svg/garbage.svg')
export const ass_img_language = require('../svg/language.svg')
export const ass_img_language_b = require('../svg/language_b.svg')
export const ass_img_language_w = require('../svg/language_w.svg')
export const ass_img_type = require('../svg/type.svg')
export const ass_img_clock = require('../svg/clock_c.svg')
export const ass_img_clock_b = require('../svg/clock_b.svg')
export const ass_img_locationPin = require('../svg/location_pin.svg')
export const ass_img_locationPin_finish = require('../svg/location_pin_finish.svg')
export const ass_img_locationDot_blue = require('../svg/locationDot_blue.svg')
export const ass_img_locationDot_green = require('../svg/locationDot_green.svg')
export const ass_img_locationDot_gray = require('../svg/locationDot_gray.svg')
export const ass_img_polygon = require('../svg/polygon.svg')
export const ass_img_line_c = require('../svg/line_c.svg')
export const ass_img_square = require('../svg/square.svg')
export const ass_img_square_w = require('../svg/square_w.svg')
export const ass_img_xLetter_b = require('../svg/x_letter_b.svg')
export const ass_img_xLetter_w = require('../svg/x_letter_w.svg')
export const ass_img_xLetter_r = require('../svg/x_letter_r.svg')
export const ass_img_playersGroup_b = require('../svg/playersGroup_b.svg')
export const ass_img_playersGroup_w = require('../svg/playersGroup_w.svg')
export const ass_img_playersGroup_p = require('../svg/playersGroup_p.svg')
export const ass_img_playersGroup_g = require('../svg/playersGroup_g.svg')
export const ass_img_teamLeader = require('../svg/teamLeader.svg')
export const ass_img_profit_b = require('../svg/profit_b.svg')
export const ass_img_walking_b = require('../svg/walking.svg')
export const ass_img_battery_c = require('../svg/battery_c.svg')
export const ass_img_growth_c = require('../svg/growth_c.svg')

export const ass_img_playVideo_c = require('../svg/playVideo_c.svg')
export const ass_img_new_c = require('../svg/new_c.svg')
export const ass_img_infoBtn_b = require('../svg/infoBtn.svg')
export const ass_img_newFile_c = require('../svg/newFile.svg')

export const ass_img_rotate90degree_w = require('../svg/rotate90degree_w.svg')
export const ass_img_filter_w = require('../svg/filter_w.svg')

export const ass_img_check_simple_two_purple = require('../svg/check_simple_two_purple.svg')
export const ass_img_check_simple_two = require('../svg/check_simple_two.svg')
export const ass_img_check_simple = require('../svg/check_simple.svg')


// top bar
export const ass_img_menu_b = require('../svg/menu.svg')
export const ass_img_logo_p = require('../svg/logo.svg')
export const ass_img_logoFull_p = require('../svg/logoFull.svg')
export const ass_img_logoFull2_p = require('../svg/logoFull2.svg')
export const ass_img_help_b = require('../svg/help.svg')
export const ass_img_install_b = require('../svg/install.svg')

export const ass_img_dices_b = require('../svg/dices_b.svg')


// about
export const ass_img_graph_c = require("../svg/graph_c.svg")
export const ass_img_cameraVideo_c = require('../svg/cameraVideo_c.svg')


// ========= navigation bar ============

// oldMap
export const ass_img_oldMapCompass = require('../images/map_test10.jpg')
export const ass_img_map_treasure = require('../svg/map_treasure_c.svg')
export const ass_img_guide= require('../images/guide.jpg')
export const ass_img_home= require('../images/home.jpg')
export const ass_img_outdoor= require('../images/outdoor.jpg')
export const ass_img_outdoor2= require('../images/outside.jpg')
export const ass_img_virtual= require('../images/virtual.jpg')
export const ass_img_selfGuided= require('../images/selfGuided.jpg')
export const ass_img_teamWork= require('../images/teamWork.jpg')

export const ass_img_questRules_pl = require('../svg/list_pl.svg')
export const ass_img_questRules_p = require('../svg/list_p.svg')
export const ass_img_questRules_w = require('../svg/list_w.svg')
export const ass_img_send_p = require('../svg/send_p.svg')
export const ass_img_send_b = require('../svg/send_b.svg')
export const ass_img_info_pl = require('../svg/info_round_pl.svg')
export const ass_img_info_p = require('../svg/info_round_p.svg')
export const ass_img_info_g = require('../svg/info_round_g.svg')
export const ass_img_info_w = require('../svg/info_round_w.svg')
export const ass_img_info_b = require('../svg/info_round_b.svg')
export const ass_img_info2_b = require('../svg/information_b.svg')
export const ass_img_info2_w = require('../svg/information_w.svg')
export const ass_img_info3_b = require('../svg/info3_b.svg')
export const ass_img_info3_w = require('../svg/info3_w.svg')
export const ass_img_info3_p = require('../svg/info3_p.svg')
export const ass_img_info4_b = require('../svg/info4_b.svg')

export const ass_img_outdoor_b = require('../svg/outdoor_b.svg')
export const ass_img_indoor_b = require('../svg/indoor_b.svg')
export const ass_img_online_b = require('../svg/online_b.svg')

export const ass_img_inbox_p = require('../svg/inbox_p.svg')
export const ass_img_inbox_w = require('../svg/inbox_w.svg')
export const ass_img_inbox_g = require('../svg/inbox_g.svg')

export const ass_img_cards_pl = require('../svg/cards2_pl.svg')
export const ass_img_cards_p = require('../svg/cards2_p.svg')
export const ass_img_cards_b = require('../svg/cards2_b.svg')
export const ass_img_cards_w = require('../svg/cards2_w.svg')
export const ass_img_chat_pl = require('../svg/chat_pl.svg')
export const ass_img_chat_p = require('../svg/chat_p.svg')
export const ass_img_chat_g = require('../svg/chat_g.svg')
export const ass_img_chat_b = require('../svg/chat_b.svg')
export const ass_img_chat_w = require('../svg/chat_w.svg')
export const ass_img_envelope = require('../svg/envelope.svg')
export const ass_img_smiley_b = require('../svg/smiley.svg')
export const ass_img_target_pl = require('../svg/target_pl.svg')
export const ass_img_target_p = require('../svg/target_p.svg')
export const ass_img_target_g = require('../svg/target_g.svg')
export const ass_img_target_w = require('../svg/target_w.svg')
export const ass_img_map_pl = require('../svg/map2_pl.svg')
export const ass_img_map_p = require('../svg/map2_p.svg')
export const ass_img_map_g = require('../svg/map2_g.svg')
export const ass_img_map_w = require('../svg/map2_w.svg')
export const ass_img_map_b = require('../svg/map2_b.svg')
export const ass_img_search_p = require('../svg/search3_p.svg')
export const ass_img_search_g = require('../svg/search3_g.svg')
export const ass_img_search_w = require('../svg/search3_w.svg')
export const ass_img_searchEmpty_w = require('../svg/searchEmpty_w.svg')
export const ass_img_searchEmpty_b = require('../svg/searchEmpty_b.svg')
export const ass_img_tickets_pl = require('../svg/ticket3_pl.svg')
export const ass_img_puzzle2_pl = require('../svg/puzzle2_pl.svg')
export const ass_img_puzzle2_p = require('../svg/puzzle2_p.svg')
export const ass_img_puzzle2_g = require('../svg/puzzle2_g.svg')
export const ass_img_puzzle2_w = require('../svg/puzzle2_w.svg')
export const ass_img_puzzle_c = require('../svg/puzzle_c.svg')
export const ass_img_puzzlePiece_p = require('../svg/puzzlePiece_p.svg')
export const ass_img_puzzlePiece_w = require('../svg/puzzlePiece_w.svg')
export const ass_img_puzzlePiece_b = require('../svg/puzzlePiece_b.svg')
export const ass_img_gallery_w = require('../svg/gallery_w.svg')
export const ass_img_gallery_p = require('../svg/gallery_p.svg')
export const ass_img_terms_c = require('../svg/terms_c.svg')

export const ass_img_tickets_p = require('../svg/ticket3_p.svg')
export const ass_img_tickets_g = require('../svg/ticket3_g.svg')
export const ass_img_tickets_w = require('../svg/ticket3_w.svg')
export const ass_img_tickets_b = require('../svg/ticket3_b.svg')
export const ass_img_avatar_pl = require('../svg/avatar2_pl.svg')
export const ass_img_avatar_p = require('../svg/avatar2_p.svg')
export const ass_img_avatar_g = require('../svg/avatar2_g.svg')
export const ass_img_avatar_w = require('../svg/avatar2_w.svg')
export const ass_img_avatar3_b = require('../svg/avatar3.svg')
export const ass_img_articles_g = require('../svg/articles_g.svg')
export const ass_img_articles_p = require('../svg/articles_p.svg')
export const ass_img_articles_w = require('../svg/articles_w.svg')
export const ass_img_dashboard_pl = require('../svg/dashboard2_pl.svg')
export const ass_img_dashboard_w = require('../svg/dashboard2_w.svg')
export const ass_img_dashboard_p = require('../svg/dashboard2_p.svg')
export const ass_img_dashboard_g = require('../svg/dashboard2_g.svg')
export const ass_img_calendar_pl = require('../svg/calendar2_pl.svg')
export const ass_img_calendar_p = require('../svg/calendar2_p.svg')
export const ass_img_calendar_g = require('../svg/calendar2_g.svg')
export const ass_img_calendar_b = require('../svg/calendar2_b.svg')
export const ass_img_calendar_w = require('../svg/calendar2_w.svg')
export const ass_img_edit_pl = require('../svg/edit2_pl.svg')
export const ass_img_edit_p = require('../svg/edit2_p.svg')
export const ass_img_edit_g = require('../svg/edit2_g.svg')
export const ass_img_edit_b = require('../svg/edit2_b.svg')
export const ass_img_edit_w = require('../svg/edit2_w.svg')
export const ass_img_camera_b = require('../svg/camera_b.svg')
export const ass_img_camera_w = require('../svg/camera_w.svg')
export const ass_img_video_w = require('../svg/video_w.svg')
export const ass_img_video_p = require('../svg/video_p.svg')
export const ass_img_video_b = require('../svg/video_b.svg')



export const ass_svg_contract_b = require('../svg/contract_b.svg')

export const ass_img_qrBox = require('../svg/qr_box_black.svg')
export const ass_img_download_w = require('../svg/download_w.svg')
export const ass_img_send_w = require('../svg/send_w.svg')
export const ass_img_download_b = require('../svg/download_b.svg')
export const ass_img_upload_b = require('../svg/folderWithDocument_b.svg')
export const ass_img_copy_w = require('../svg/copy_w.svg')
export const ass_img_copy2_b = require('../svg/copy_b.svg')
export const ass_img_power_w = require('../svg/power_button_white.svg')
export const ass_img_undo = require('../svg/undo.svg')
export const ass_img_redo = require('../svg/redo.svg')
export const ass_img_textColor = require('../svg/text_color.svg')
export const ass_img_colors_w = require('../svg/colors_w.svg')
export const ass_img_marker = require('../svg/marker.svg')
export const ass_img_letterB = require('../svg/letterB.svg')
export const ass_img_letterI = require('../svg/letterI.svg')
export const ass_img_underline = require('../svg/underline.svg')
export const ass_img_strikeThough = require('../svg/strikethrough.svg')
export const ass_img_link = require('../svg/link.svg')
export const ass_img_disconnectedLink = require('../svg/disconnected_chains.svg')
export const ass_img_alignLeft = require('../svg/left_align.svg')
export const ass_img_alignCenter = require('../svg/center_alignment.svg')
export const ass_img_alignRight = require('../svg/right_alignment.svg')
export const ass_img_alignJustify = require('../svg/justify.svg')
export const ass_img_numbering = require('../svg/numbering.svg')
export const ass_img_bulletsList_b = require('../svg/bulletedList_b.svg')
export const ass_img_bulletsList_w = require('../svg/bulletedList_w.svg')
export const ass_img_bulletsList_p = require('../svg/bulletedList_p.svg')
export const ass_img_horizonLine = require('../svg/horizon_line.svg')
export const ass_img_clean = require('../svg/wiping_swipe_for_floors.svg')
export const ass_img_image = require('../svg/image_b.svg')
export const ass_img_image2 = require('../svg/image2_b.svg')
export const ass_img_videoPlayer = require('../svg/video_player.svg')
export const ass_img_videoPlayer2 = require('../svg/video_player2.svg')
export const ass_img_musicPlayer = require('../svg/musicPlayer_black.svg')

export const ass_img_copyLink_b = require('../svg/copyLink_b.svg')

export const ass_img_reviews_b = require('../svg/review_b.svg')
export const ass_img_reviews_w = require('../svg/review_w.svg')

export const ass_img_star = require('../svg/star.svg')
export const ass_img_empty_star = require('../svg/star_empty.svg')
export const ass_img_half_star = require('../svg/star_half_empty.svg')
export const ass_img_threeStars = require('../svg/stars_three.svg')
export const ass_img_oneStar_w = require('../svg/star_one_w.svg')

//about
export const ass_img_googleStore = require('../images/googleStore.png')
export const ass_img_appStore = require('../images/appStore.png')
export const ass_img_about_TqApp = require('../images/about_tq_app.png')
export const ass_img_about_multiPlatform = require('../svg/multiPlatforms.png')
export const ass_img_about_cards = require('../images/about_cards.jpg')
export const ass_img_about_map_rectangles = require('../images/about_map_rectangles.jpg')
export const ass_img_about_map_route = require('../images/about_map_route.png')
export const ass_img_about_missionList = require('../images/about_missions_list.png')
export const ass_img_about_missionList_levels = require('../images/about_missionsList_levels.png')

// gif
export const ass_img_about_tqAppGif = require('../gifs/tqAppGif.gif')
export const ass_gif_lock_options = require('../gifs/lock_options.gif')
export const ass_gif_lock_quiz = require('../gifs/lock_quiz.gif')
export const ass_gif_lock_includeText= require('../gifs/lock_includeText.gif')
export const ass_gif_lock_text= require('../gifs/lock_text.gif')
export const ass_gif_firework= require('../gifs/fireworks.gif')

// locks
export const ass_img_lock_w = require('../svg/lock_w.svg')
export const ass_img_lock_bgRed_w = require('../svg/lock_BgWhite.svg')
export const ass_img_hammer_p = require('../svg/hammer_p.svg')
export const ass_img_hammer_w = require('../svg/hammer_w.svg')

export const ass_img_lockText_b = require('../svg/lock_text_b.svg')
export const ass_img_lockText_p = require('../svg/lock_text_p.svg')
export const ass_img_lockText_w = require('../svg/lock_text_w.svg')
export const ass_img_lockIncludeText_b = require('../svg/lock_includeText.svg')
export const ass_img_lockOptions_b = require('../svg/lock_options.svg')
export const ass_img_lockQuiz_b = require('../svg/lock_quiz.svg')
export const ass_img_lockTimer_b = require('../svg/lock_timer_b.svg')
export const ass_img_svg_lockTimer_w = require('../svg/lock_timer_w.svg')
export const ass_img_lockVideo_b = require('../svg/lock_video.svg')
export const ass_img_lockImage_b = require('../svg/lock_image.svg')

export const ass_img_lockImg = require('../svg/lock_image2.svg')
export const ass_img_lockVideo = require('../svg/lock_video2.svg')
export const ass_img_lockOption = require('../svg/lock_options2.svg')
export const ass_img_lockIncludesWords = require('../svg/lock_includeWords.svg')
export const ass_img_lockWords= require('../svg/lock_words.svg')
export const ass_img_QrCode_b = require('../svg/qr_code_b.svg')
export const ass_img_QrCode_w = require('../svg/qrCode_w.svg')
export const ass_img_lockLocation = require('../svg/locationMap_c.svg')

export const ass_img_refresh_b  = require('../svg/refresh_b.svg')
export const ass_img_plusSign_b = require('../svg/plusSign_b.svg')
export const ass_img_equal_b    = require('../svg/equal_b.svg')

export const ass_img_save_w     = require('../svg/save_w.svg')
export const ass_img_change_b   = require('../svg/chnage_b.svg')
export const ass_img_exit_b     = require('../svg/exit3_b.svg')
export const ass_img_exit_w     = require('../svg/exit3_w.svg')

export const ass_svg_gearHelper_b = require('../svg/gearHelper_b.svg')
export const ass_svg_gearHelper_w = require('../svg/gearHelper_w.svg')

export const ass_img_settingsGear_p = require('../svg/settingsGear_p.svg')
export const ass_img_settingsGear_w = require('../svg/settingsGear_w.svg')
export const ass_img_settingsGear_b = require('../svg/settingsGear_b.svg')
export const ass_img_note_p = require('../svg/note_p.svg')
export const ass_img_note_w = require('../svg/note_w.svg')
export const ass_img_document_b = require('../svg/document_b.svg')
export const ass_img_document_p = require('../svg/document_p.svg')
export const ass_img_document_g = require('../svg/document_g.svg')
export const ass_img_document_w = require('../svg/document_w.svg')
export const ass_img_tos_w = require('../svg/tos_w.svg')
export const ass_img_tos_p = require('../svg/tos_p.svg')
export const ass_img_tos_b = require('../svg/tos_b.svg')
export const ass_img_ticket4_p = require('../svg/ticket4_p.svg')
export const ass_img_ticket4_g = require('../svg/ticket4_g.svg')
export const ass_img_ticket4_w = require('../svg/ticket4_w.svg')


export const ass_svg_drive_white = require('../svg/drive_white.svg')
export const ass_svg_newFolder_black = require('../svg/newFolder_black.svg')
export const ass_svg_folder_color = require('../svg/folder_color.svg')

// social
export const ass_img_facebook_w = require('../svg/facebook_w.svg')
export const ass_img_facebook_c = require('../svg/facebook_c.svg')
export const ass_img_youtube_w = require('../svg/youtube_w.svg')
export const ass_img_instagram_w = require('../svg/instagram_w.svg')
export const ass_img_whatsapp_w = require('../svg/whatsapp_w.svg')
export const ass_img_twitter_w  = require('../svg/twitter_w.svg')
export const ass_img_mail_w     = require('../svg/mail_w.svg')
export const ass_img_mail_p     = require('../svg/mail_p.svg')
export const ass_img_mail_b2     = require('../svg/mail_b2.svg')
export const ass_img_mail_b     = require('../svg/mail_b.svg')
export const ass_img_google_w     = require('../svg/google.svg')
export const ass_img_google_c     = require('../svg/google_c.svg')
export const ass_img_phone_w     = require('../svg/phone_w.svg')
export const ass_img_link_w     = require('../svg/link_w.svg')
export const ass_img_gmail_c     = require('../svg/gmail_c.svg')
export const ass_img_chrome_c     = require('../svg/logoChrome_c.svg')
export const ass_img_windows_c     = require('../svg/logoWindows_c.svg')
export const ass_img_logoAndroid_c    = require('../svg/logoAndroidPhone.svg')
export const ass_img_logoApplePhone_c    = require('../svg/logoApplePhone.svg')
export const ass_img_logoSafariOrChrome    = require('../svg/logoSafariOrChrome.svg')
export const ass_img_logoSafari_c       = require('../svg/logoSafari_c.svg')
export const ass_img_logoApplePc_c      = require('../svg/logoApplePc_c.svg')

export const ass_img_embedded_w      = require('../svg/embedded_w.svg')

//
export const ass_img_tablet_b = require('../svg/tablet_b.svg')
export const ass_img_mobile_b = require('../svg/phone_b.svg')
export const ass_img_laptop_b = require('../svg/pcScreen_b.svg')
export const ass_img_moneyBag = require('../svg/money_bag.svg')
export const ass_img_currency_c = require('../svg/currency_c.svg')


// others
export const ass_img_oneHundred = require('../svg/oneHundred.svg')
export const ass_img_location = require('../svg/location.svg')
export const ass_img_user_b = require('../svg/user_bw.svg')
export const ass_img_user_w = require('../svg/user_w.svg')
export const ass_img_unknownUser_w = require('../svg/unknownUser_w.svg')
export const ass_img_heart_empty = require('../svg/heart_empty.svg')
export const ass_img_heart_full = require('../svg/heart_full.svg')
export const ass_img_share = require('../svg/share.svg')
export const ass_img_edit = require('../svg/edit.svg')
export const ass_img_closeRed = require('../svg/close_red2.svg')

export const ass_img_shoppingCart_w = require('../svg/shoppingCart_white.svg')
export const ass_img_shoppingCart_p = require('../svg/shoppingCart_purple.svg')
export const ass_img_shoppingCart_g = require('../svg/shoppingCart_g.svg')
export const ass_img_shoppingBag_w = require('../svg/shoppingBag_white.svg')

export const ass_img_searchIdea = require('../svg/search_idea.svg')
export const ass_img_idea_p = require('../svg/idea2_p.svg')
export const ass_img_idea_b = require('../svg/idea2_b.svg')
export const ass_img_idea_c = require('../svg/idea_c.svg')
export const ass_img_idea_w = require('../svg/idea2_w.svg')
export const ass_img_noWifi = require('../svg/no_wifi.svg')

// arrows
export const ass_svg_arrow_return_b = require('../svg/arrow_return_b.svg')
export const ass_svg_arrow_round_black = require('../svg/arrow_round_black.svg')
export const ass_img_arrow_heads_down = require('../svg/arrowheads_down.svg')
export const ass_img_arrow_right_w = require('../svg/arrow_right_white.svg')
export const ass_img_arrow_left_w = require('../svg/left_arrow_white.svg')
export const ass_img_arrow_left_b = require('../svg/arrow_head_left_b.svg')
export const ass_img_arrow_right_b = require('../svg/arrow_right_b.svg')
export const ass_img_arrow_head_left_p = require("../svg/arrow_head_left_p.svg")
export const ass_img_arrow_head_right_p = require("../svg/arrow_head_right_p.svg")
export const ass_img_arrow_left_p = require("../svg/arrow_left_p.svg")
export const ass_img_caretDown_b = require('../svg/caretArrowDown_b.svg')
export const ass_img_caretDown_w = require('../svg/caretArrowDown_w.svg')
export const ass_img_caretUp_b = require('../svg/caretArrowUp_b.svg')
export const ass_img_caretUp_w = require('../svg/caretArrowUp_w.svg')
export const ass_img_arrow_down_b = require('../svg/arrow_down_b.svg')
export const ass_img_arrow_down_w = require('../svg/arrow_down_w.svg')
export const ass_img_arrow_up_b = require('../svg/arrow_up_b.svg')
export const ass_img_arrow_up_w = require('../svg/arrow_up_w.svg')


export const ass_img_home_b = require('../svg/home_b.svg')


export const ass_img_cloud_backup_down_arrow_b = require('../svg/cloud_backup_down_arrow_b.svg')
export const ass_img_cloud_backup_up_arrow_b = require('../svg/cloud_backup_up_arrow_b.svg')


export const ass_img_locationOff = require("../svg/location_turnOff.svg")
export const ass_img_shareLocation = require('../svg/shareLocation.svg')

export const ass_img_cameraBtn_beforeRecording = require("../svg/camera_button_preRecording.svg")
export const ass_img_cameraBtn_recording = require("../svg/camera_button_recording.svg")
export const ass_img_flash_w = require("../svg/flash_w.svg")
export const ass_img_flashlight_w = require("../svg/flashlight_w.svg")
export const ass_img_gallery_b = require("../svg/gallery_b.svg")


export const ass_img_svg_fullscreen_b = require('../svg/fullscreen_b.svg')

export const ass_img_flagFrench_c = require("../svg/flag_france.svg")
export const ass_img_flagNetherlands_c = require("../svg/flag_netherlands.svg")
export const ass_img_flagIsrael_c = require("../svg/flag_israel2.svg")
export const ass_img_planetEarth_c = require("../svg/planetEarth_c.svg")
export const ass_img_creditCard_b = require("../svg/creditCard_b.svg")
export const ass_img_flagUsa_c = require("../svg/flag_usa.svg")
export const ass_img_flagSpain_c = require("../svg/flag_spain.svg")
export const ass_img_flagEgypt_c = require("../svg/flagEgypt.svg")

export const ass_img_myLocation_blue = require("../svg/myLocation_blue.svg")
export const ass_img_myLocation_gray = require("../svg/myLocation_gray.svg")


export const ass_img_edit2_b = require("../svg/edit_b.svg")
export const ass_img_edit2_w = require("../svg/edit_w.svg")

export const ass_img_glob_b = require("../svg/globe_b.svg")


export const ass_img_threeDots = require("../svg/dots_three.svg")

export const ass_warning_b = require("../svg/warning_b.svg")
export const ass_warning_p = require("../svg/warning_p.svg")
export const ass_warning_g = require("../svg/warning_g.svg")
export const ass_warning_w = require("../svg/warning_w.svg")


export const ass_svg_maze_triangular_ca = require("../svg/maze_triangular_ca.svg")
export const ass_svg_maze_triangular_c = require("../svg/maze_triangular_c.svg")
export const ass_svg_maze_triangular_g = require("../svg/maze_triangular_g.svg")
export const ass_svg_maze_square_c = require("../svg/maze_square_c.svg")
export const ass_svg_maze_square_g = require("../svg/maze_square_g.svg")
export const ass_svg_maze_rectangular_c = require("../svg/maze_rectangular_c.svg")
export const ass_svg_maze_rectangular_g = require("../svg/maze_rectangular_g.svg")
export const ass_svg_maze_hexagonal_c = require("../svg/maze_hexagonal_c.svg")
export const ass_svg_maze_hexagonal_g = require("../svg/maze_hexagonal_g.svg")
export const ass_svg_maze_octagonal_c = require("../svg/maze_octagonal_c.svg")
export const ass_svg_maze_octagonal_g = require("../svg/maze_octagonal_g.svg")
export const ass_svg_maze_rhombus_c = require("../svg/maze_rhombus_c.svg")
export const ass_svg_maze_rhombus_g = require("../svg/maze_rhombus_g.svg")
export const ass_svg_maze_circular_c = require("../svg/maze_circular_c.svg")
export const ass_svg_maze_circular_g = require("../svg/maze_circular_g.svg")
export const ass_svg_maze_oval_c = require("../svg/maze_oval_c.svg")
export const ass_svg_maze_oval_g = require("../svg/maze_oval_g.svg")
export const ass_svg_maze_star_c = require("../svg/maze_star_c.svg")
export const ass_svg_maze_star_g = require("../svg/maze_star_g.svg")
export const ass_svg_maze_heart_c = require("../svg/maze_heart_c.svg")
export const ass_svg_maze_heart_g = require("../svg/maze_heart_g.svg")




export const ass_svg_museum_store = require("../svg/museum_store.svg")
export const ass_svg_nonProfit_store = require("../svg/nonProfit_store.svg")
export const ass_svg_schools_store = require("../svg/schools_store.svg")
export const ass_svg_store_black = require("../svg/store_black.svg")


export const ass_img_priceTag_b = require("../svg/priceTag.svg")
export const ass_img_coupon_b = require("../svg/coupon_b.svg")
export const ass_img_disable_b = require("../svg/disable_b.svg")


export const ass_svg_foreign_w = require('../svg/foreign_w.svg')
export const ass_svg_airplane_w = require('../svg/airplane_w.svg')
export const ass_svg_hot_air_balloon_w = require('../svg/hot_air_balloon_w.svg')
export const ass_svg_paper_airplane_w = require('../svg/paper_airplane_w.svg')
export const ass_svg_helicopter_b = require('../svg/helicopter_b.svg')
export const ass_svg_paper_airplane2_w = require('../svg/paper_airplane2_w.svg')
export const ass_svg_rocket_w = require('../svg/rocket_w.svg')
export const ass_svg_rocket2_w = require('../svg/rocket2_w.svg')

export const ass_svg_film_b = require('../svg/film_b.svg')
export const ass_svg_photo_b = require('../svg/photo_b.svg')




